import type { CleaveOptions } from 'cleave.js/options'
import { isNil } from 'ramda'

import { blocks, delimiters } from './format'

export type CallingCode =
  | '+420' // Czech republic
  | '+421' // Slovakia
  | '+48' //  Poland
  | '+90' //  Turkey
  | '+34' // Spain
  | '+966' // Saudi arabia

type CallingCodeOptions = {
  placeholder: string
  format: CleaveOptions
}

const callingCodesMap: Record<CallingCode, CallingCodeOptions> = {
  '+420': {
    placeholder: '123 456 789',
    format: {
      blocks: [blocks.three, blocks.three, blocks.three],
      delimiter: delimiters.unbreakableSpace,
      numericOnly: true,
    },
  },
  '+421': {
    placeholder: '123 456 789',
    format: {
      blocks: [blocks.three, blocks.three, blocks.three],
      delimiter: delimiters.unbreakableSpace,
      numericOnly: true,
    },
  },
  '+48': {
    placeholder: '123 456 789',
    format: {
      blocks: [blocks.three, blocks.three, blocks.three],
      delimiter: delimiters.unbreakableSpace,
      numericOnly: true,
    },
  },
  '+34': {
    placeholder: '123 456 789',
    format: {
      blocks: [blocks.three, blocks.three, blocks.three],
      delimiter: delimiters.unbreakableSpace,
      numericOnly: true,
    },
  },
  '+90': {
    placeholder: '123 456 7890',
    format: {
      blocks: [blocks.three, blocks.three, blocks.four],
      delimiter: delimiters.unbreakableSpace,
      numericOnly: true,
    },
  },
  '+966': {
    placeholder: '011 123 3456',
    format: {
      blocks: [blocks.three, blocks.three, blocks.four],
      delimiter: delimiters.unbreakableSpace,
      numericOnly: true,
    },
  },
}

export const getCallingCodeConfig = (callingCode: CallingCode) => {
  const callingCodeConfig = callingCodesMap[callingCode]

  if (isNil(callingCodeConfig)) {
    return undefined
  }

  return callingCodeConfig
}
